export default "__VITE_ASSET__BsqchhP0__"